import DataTable from './dataTable'

/******************************************************************************
 *  Users
 *****************************************************************************/

/**
 * @type {Users}
 */
export default class Users extends DataTable {

    /**
     * @param {String} resource
     */
    constructor () {
        super('datatable/masters', '/masters')
        this.columns = [
            this.prototypes.column('updated_at', 'users.updated_at', true, false),
            this.prototypes.column('first_name', 'users.first_name', true, true),
            this.prototypes.column('email', 'users.email', true, true),
            this.prototypes.column('group_name', 'g.name', true, true),
            this.prototypes.column('created_at', 'users.created_at', true, true),
        ]
    }
}